export const enum MODES_OPTIONS {
  NEW = "NEW",
  EDIT = "EDIT",
  VIEW = "VIEW",
  MODAL = "MODAL",
  COPY = "COPY",
}
